
import { Component, Prop, Vue } from "vue-property-decorator";

import REMOVE_EDUCATION from "@/apollo/profile/educations/RemoveEducation.gql";

import CardItem from "@/components/profile/common/CardItem.vue";
import CardContainer from "@/components/profile/common/CardContainerNew.vue";
import EducationForm from "@/components/profile/educations/EducationForm.vue";

import { User_Education } from "@/generated/graphql";
import { Moment } from 'moment';
import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';

@Component({
    components: {
        CardItem,
        CardContainer,
        EducationForm,
    },
})
export default class ProfileEducationCard extends Vue {
    @Prop({ type: Object, required: true }) readonly education!: User_Education;
    @Prop({ type: String, required: true }) readonly userId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    isModalOpen: boolean = false;

    get startDate(): string | undefined {
        if (this.education?.start_date) {
            const startDate = this.$moment(this.education?.start_date) as unknown as Moment;
            return startDate.format("DD MMM, YYYY")
        }

        return undefined;
    }

    get endDate(): string | undefined {
        if (this.education?.end_date) {
            const endDate = this.$moment(this.education?.end_date) as unknown as Moment;
            return endDate.format("DD MMM, YYYY")
        }

        return undefined;
    }

    showModal(): void {
        this.isModalOpen = !this.isModalOpen;
    }

    async removeEducation(): Promise<void> {
        try {
            await this.remove();
            this.$emit('removed');

            this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage(`${this.education.institution} is removed from your education.`)
            );
        } catch (error) {
            var msg = "";
            if (error instanceof Error) {
                msg = error.message;
            } else {
                msg = error as string;
            }
            this.$eventBus.emit(
                NOTIFICATION,
                Message.errorMessage(msg)
            );
        }
    }

    async remove(): Promise<void> {
        await this.$apollo.mutate({
            mutation: REMOVE_EDUCATION,
            variables: {
                id: this.education.id,
            },
        });
    }
}
